import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Input } from '../ui/input';
import { Briefcase, Search, MapPin, DollarSign, CheckCircle } from 'lucide-react';

export default function JobsTab({ jobs, search, setSearch, setSelectedJob }) {
  const filteredJobs = jobs.filter(j => 
    !search || 
    j.title.toLowerCase().includes(search.toLowerCase()) ||
    j.description?.toLowerCase().includes(search.toLowerCase()) ||
    j.location?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="space-y-4">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <Input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search jobs..." className="pl-9 rounded-full" data-testid="job-search" />
      </div>

      {filteredJobs.length > 0 ? (
        <div className="grid sm:grid-cols-2 gap-4">
          {filteredJobs.map(job => (
            <Card key={job.id} className="border-0 shadow-sm rounded-2xl hover:shadow-md transition-shadow cursor-pointer" onClick={() => setSelectedJob(job)}>
              <CardContent className="p-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-sky-50 flex items-center justify-center shrink-0">
                    <Briefcase className="w-5 h-5 text-sky-600" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2">
                      <div>
                        <p className="font-semibold text-sm">{job.title}</p>
                        {job.felony_friendly && (
                          <Badge className="bg-emerald-50 text-emerald-700 text-xs mt-1">
                            <CheckCircle size={10} className="mr-1" /> Second Chance
                          </Badge>
                        )}
                      </div>
                    </div>
                    {job.description && <p className="text-xs text-muted-foreground mt-2 line-clamp-2">{job.description}</p>}
                    <div className="flex flex-wrap gap-3 mt-2 text-xs text-muted-foreground">
                      {job.location && <span className="flex items-center gap-1"><MapPin size={10} /> {job.location}</span>}
                      {job.wage && <span className="flex items-center gap-1"><DollarSign size={10} /> {job.wage}</span>}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
        <Card className="border-2 border-dashed rounded-2xl">
          <CardContent className="py-12 text-center">
            <Briefcase className="w-12 h-12 text-muted-foreground/30 mx-auto mb-3" />
            <p className="text-muted-foreground">No job listings available yet. Check back soon!</p>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
